import { MainHeader, SearchBar } from "@/components";
import VendorsQuotes from "@/components/Quotes/VendorQuote/VendorsQuotes";
import Statistics from "@/components/StatisticsData/StatisticsData";

export default function VendorQuotePage() {
  return (
    <>
      <MainHeader pageName="Quotes">
        <SearchBar />
      </MainHeader>
      <Statistics />
      <div className="p-5 flex gap-2 ">
        <VendorsQuotes />
      </div>
    </>
  );
}
